import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { MenuIcon } from "lucide-react";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import { Button } from "../button";
import { useSidebar } from "./useSidebar";

// Кнопка «☰» для телефона: открывает меню шторкой.
export const SidebarTrigger = ({ className, onClick, ...props }: ComponentProps<typeof Button>) => {
  const { _ } = useLingui();
  const { openMobile, setOpenMobile } = useSidebar();
  return (
    <Button
      data-slot="sidebar-trigger"
      variant="outline"
      size="icon"
      aria-label={_(msg`Open menu`)}
      aria-haspopup="dialog"
      aria-expanded={openMobile}
      className={cn("size-11 bg-transparent", className)}
      {...props}
      onClick={(event) => {
        onClick?.(event);
        setOpenMobile(true);
      }}
    >
      <MenuIcon aria-hidden="true" className="size-5.5" />
    </Button>
  );
};
